module.exports = __webpack_public_path__ + "images/smartphone-screen-1_06cb61f64a134eee714f2b27c3e793b0.png";